
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps } from 'next';
import { SUPPORTED_LOCALES, SupportedLocale } from 'i18n';
import { BrandsPage } from 'modules/seller/pages/BrandsPage';
import { MarketplaceAPI } from 'revibe-api';
export default BrandsPage;
const getStaticProps: GetStaticProps = async ({ locale }) => {
    const { data } = await MarketplaceAPI.getActiveSellers({
        language: (locale as SupportedLocale) || SUPPORTED_LOCALES.EN,
        token: process.env.REVIBE_API_TOKEN as string,
    });
    const countries = data?.map((seller) => seller.country) || [];
    return {
        props: {
            sellers: data || [],
            countries: Array.from(new Set(countries)),
        },
        revalidate: 60,
    };
};

    async function __Next_Translate__getStaticProps__18c6845d7bb__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/shop/brands/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18c6845d7bb__ as getStaticProps }
  